<script>
const { required } = require('vuelidate/lib/validators');

const formatter = new Intl.NumberFormat(`${document.documentElement.lang}-CA`, {
  currency: 'CAD',
  minimumFractionDigits: 2,
  style: 'currency',
});

export default {
  name: 'QuitCalculator',
  data() {
    return {
      average: '',
      cost: '',
      amount: '',
      time: 1,
      savings: null,
    };
  },
  computed: {
    formatedSavings() {
      return Object.keys(this.savings).reduce((acc, key) => {
        acc[key] = formatter.format(this.savings[key]).replace('CA','');;
        return acc;
      }, {});
    },
  },
  validations() {
    return {
      average: { required },
      cost: { required },
      amount: { required },
      time: { required },
    };
  },
  methods: {
    calculate() {
      if (this.average && this.cost && this.amount && this.time) {
        const dailySavings = (Number(this.average) / Number(this.amount)) * Number(this.cost);
        this.savings = {
          weekly: dailySavings * 7,
          monthly: dailySavings * 30,
          annually: dailySavings * 365,
          total: dailySavings * 365 * this.time,
        };
      } else {
        this.savings = null;
      }
    },
    preventNonNumeric(event) {
      // prevent '.' if there is already a '.' or '.' would be the first character
      if (event.key === '.' && (event.target.value.includes('.') || event.target.value === '')) {
        event.preventDefault();
      }

      // prevent anything not numeric
      if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].includes(event.key)) {
        event.preventDefault();
      }
    },
    submit() {
      this.$v.$touch();
      this.calculate();
    },
  },
};
</script>
